import { handleApiGet } from "./api";
import { BackendUrl } from "./newBackendApi";

export function getSearchCount(token: string, query: string) {
  return handleApiGet(`${BackendUrl}/admin/filter/total${query}`, {
    Authorization: token,
  });
}
